<template>
  <div class="wrapper">
    <div class="animated fadeIn">
      <b-card header-tag="header" footer-tag="footer">
        <div slot="header">
          <i class="fa fa-truck"></i
          ><strong>
            {{ title }}
            <b-spinner v-if="loading" class="float-right" small></b-spinner>
          </strong>
        </div>
        <b-form @submit="onSubmit" @reset="onReset" v-if="show">
          <b-row>
            <b-col>
              <process-data @update-loading="loading = $event"></process-data>
            </b-col>
          </b-row>

          <b-button
            variant="primary"
            type="submit"
            :disabled="loading"
            class="float-right"
          >
            <span class="mr-1">Guardar</span>
            <b-spinner
              v-if="loading"
              variant="light"
              class="float-right"
              small
            ></b-spinner>
          </b-button>
          <span>{{ date }}</span>
          <b-button
            variant="danger"
            type="reset"
            :disabled="loading"
            class="float-right mr-1"
          >
            Cancelar todo
          </b-button>
        </b-form>
      </b-card>
    </div>
  </div>
</template>

<script>
import ProcessData from "./ProcessData";
import { mapState } from "vuex";

export default {
  name: "CreateProcess",
  components: {
    ProcessData
  },
  data() {
    return {
      title: "Ingreso",
      loading: false,
      show: true,
      date: new Date()
        .toJSON()
        .slice(0, 10)
        .replace(/-/g, "-")
    };
  },
  computed: {
    ...mapState("bagnoProcessModule", {
      process_type: state => state.form.process_type
    })
  },
  methods: {
    onSubmit(evt) {
      evt.preventDefault();
      this.createProcess();
    },
    onReset(evt) {
      evt.preventDefault();
      // Reset our form values
      this.form.email = "";
      this.form.name = "";
      this.form.food = null;
      this.form.checked = [];
      // Trick to reset/clear native browser form validation state
      this.show = false;
      this.$nextTick(() => {
        this.show = true;
      });
    },
    async createProcess() {
      const thisV = this;
      thisV.loading = true;
      const data = {
        process_type: thisV.process_type,
        date: new Date()
          .toJSON()
          .slice(0, 10)
          .replace(/-/g, "-")
      };

      try {
        const response = await thisV.$axios({
          method: "POST",
          url: "/bagno/process/",
          data: data
        });
        thisV.$toast.success(
          "Proceso #" + response.data.number + " creado con éxito",
          ""
        );
        thisV.loading = false;
        thisV.$router.push({ name: "bagno-procesos-listado", params: data });
      } catch (error) {
        thisV.$toast.error("Problemas al crear proceso", "");
        thisV.loading = false;
      }
    },
    inputSoloNumero(event) {
      event.target.value = event.target.value.replace(/[^0-9]/, "");
    }
  }
};
</script>

<style scoped></style>
